import React from 'react'
import { Modal, Button } from 'antd'
import { LinkOutlined, UploadOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { GR_ADD_INVOICE_BUTTON_LABEL } from 'src/utils/goodsReceiptingMatchHelpers'
import { GR_LINK_EXISTING_COPY } from 'src/utils/goodsReceiptingLinkExistingHelpers'

/**
 * Add invoice entry: choose Link existing vs Upload new
 * instead of jumping straight into upload.
 */
const GrAddInvoiceChooserModal = ({
  visible,
  order,
  onCancel,
  onLinkExisting,
  onUploadNew,
}) => {
  if (!order) return null

  const po = String(order.purchaseOrderNumber || '').trim()
  const supplierTitle = String(order.supplier?.title || '').trim()

  return (
    <StyledModal
      title={GR_ADD_INVOICE_BUTTON_LABEL}
      visible={visible}
      onCancel={onCancel}
      footer={<Button onClick={onCancel}>Cancel</Button>}
      destroyOnClose
      width={480}
    >
      <Lead>{GR_LINK_EXISTING_COPY.chooserLead}</Lead>
      {(po || supplierTitle) && (
        <ContextLine>
          {po ? (
            <>
              PO <strong>{po}</strong>
            </>
          ) : null}
          {po && supplierTitle ? ' · ' : null}
          {supplierTitle || null}
        </ContextLine>
      )}
      <OptionList>
        <OptionButton type='primary' onClick={onLinkExisting}>
          <OptionIcon $onPrimary>
            <LinkOutlined />
          </OptionIcon>
          <OptionText $onPrimary>
            <strong>{GR_LINK_EXISTING_COPY.linkExistingOptionTitle}</strong>
            <span>{GR_LINK_EXISTING_COPY.linkExistingOptionHint}</span>
          </OptionText>
        </OptionButton>
        <OptionButton type='default' onClick={onUploadNew}>
          <OptionIcon>
            <UploadOutlined />
          </OptionIcon>
          <OptionText>
            <strong>{GR_LINK_EXISTING_COPY.uploadNewOptionTitle}</strong>
            <span>{GR_LINK_EXISTING_COPY.uploadNewOptionHint}</span>
          </OptionText>
        </OptionButton>
      </OptionList>
    </StyledModal>
  )
}

const StyledModal = styled(Modal)`
  .ant-modal-body {
    padding-top: 12px;
  }
`

const Lead = styled.p`
  margin: 0 0 12px;
  color: #595959;
  line-height: 1.5;
  font-size: 14px;
`

const ContextLine = styled.p`
  margin: 0 0 16px;
  font-size: 13px;
  color: #8c8c8c;
  line-height: 1.4;
`

const OptionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const OptionButton = styled(Button)`
  && {
    display: flex;
    align-items: flex-start;
    height: auto;
    padding: 14px 16px;
    text-align: left;
    white-space: normal;
  }

  &&.ant-btn-primary {
    background: #b5d922;
    border-color: #b5d922;
    color: #262626;

    &:hover,
    &:focus {
      background: #a4c61e;
      border-color: #a4c61e;
      color: #262626;
    }
  }
`

const OptionIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  margin-top: 2px;
  font-size: 18px;
  color: ${props => (props.$onPrimary ? '#262626' : '#389e0d')};
`

const OptionText = styled.span`
  display: flex;
  flex-direction: column;
  gap: 4px;
  line-height: 1.35;

  strong {
    color: #262626;
    font-size: 14px;
  }

  span {
    color: ${props => (props.$onPrimary ? 'rgba(0, 0, 0, 0.65)' : '#8c8c8c')};
    font-size: 13px;
  }
`

export default GrAddInvoiceChooserModal
